import { DialogContent, DialogHeader } from "../../../../components/ui/dialog";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { Form } from "../../../../components/ui/form";
import { FormInput } from "../../../../components/form-components/form-input.components";
import { Button } from "../../../../components/ui/button";
import { findErrorMessage, handleHttpError } from "../../../../utils/utils";
import { useEffect } from "react";
import { useToast } from "../../../../hooks/use-toast";
import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../../components/spinner.components";
import { useUpdateCampaignBudgetInternalByIdAdminHttp } from "../../../../hooks/http/admin/campaigns/update-budget-iternal-by-id.admin.http";
import useCampaignStore from "../../../../store/campaign.store";

const FormSchema = z.object({
  budgetInternal: z.coerce
    .number()
    .min(1, { message: "Add valid client budget" }),
});

export default function AddBudgetInternalModalAdminPartial() {
  const { toast } = useToast();

  const { campaignId } = useParams();
  const { setData } = useCampaignStore();

  const navigate = useNavigate();
  const { execute: addBudgetInternal, fetching: addingBudgetInternal } =
    useUpdateCampaignBudgetInternalByIdAdminHttp();

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
  });

  async function onSubmit(data: z.infer<typeof FormSchema>) {
    if (!campaignId) {
      return;
    }
    const response = await addBudgetInternal({
      body: {
        budgetInternal: data.budgetInternal,
      },
      pathParams: { id: campaignId },
    });

    if (!response.success) {
      return handleHttpError(response, toast);
    }

    toast({
      content: "Client budget updated successfully",
      toastType: "success",
    });
    setData(response.data.campaign);
    document.getElementById("getCampaignMetrics")?.click();
    navigate(-1);

    form.reset();
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  useEffect(() => {
    if (form.formState.errors) {
      const key = Object.keys(form.formState.errors)[0];

      if (key) {
        const error =
          form.formState.errors[key as keyof typeof form.formState.errors];
        const message = findErrorMessage(error) || "An error occurred";

        toast({
          content: message,
          toastType: "error",
        });
      }
    }
  }, [form.formState.errors]);
  return (
    <DialogContent className="flex flex-col items-center gap-5 border-border w-full max-w-lg text-center text-primary">
      <DialogHeader className="w-full">
        <div className="flex flex-col gap-2.5">
          <p className="flex gap-1 font-semibold text-28 leading-8">
            Add client budget
          </p>
        </div>
      </DialogHeader>
      <div className="border-border border-b w-full" />
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onSubmit)}
          className="relative flex flex-col gap-4 w-full"
        >
          <FormInput
            form={form}
            name="budgetInternal"
            label="Client budget"
            placeholder="Enter client budget"
            required
            type="number"
          />

          <Button
            disabled={addingBudgetInternal}
            className="bg-primarybuttonbg w-full h-14 font-semibold text-black"
          >
            {addingBudgetInternal ? (
              <Spinner width={20} />
            ) : (
              "Add Client Budget"
            )}
          </Button>
        </form>
      </Form>
    </DialogContent>
  );
}
